import React, { useState } from 'react';
import { DataGridPro, LicenseInfo, useGridApiRef } from '@mui/x-data-grid-pro';
import {
    Box,
    Switch,
  } from '@mui/material';


LicenseInfo.setLicenseKey('17ca2e8476fa658618680f9f135dbc81T1JERVI6MzU2MTYsRVhQSVJZPTE4NzMzODQyMDIwMDAsS0VZVkVSU0lPTj0x',);


export default function SettingsDataGrid(props) {
    const { k, rows, label, fullKey, handleChange } = props

    const apiRef = useGridApiRef();

    const datagridSwitchUpdate = (datagridParams) => {
        const { id, field, value } = datagridParams
        apiRef.current.updateRows([{id, [field]: !value}])
        const updatedRows = { ...rows }
        const updateKey = Object.keys(updatedRows)[id]
        const updatedRow = { ...apiRef.current.getRow(id) }
        delete updatedRow.id
        updatedRows[updateKey] = updatedRow
        handleChange(k, updatedRows)
    }

    const createRowsFromObj = (value) => {
        return Object.values(value).map((item, index) => {
            const row = { ...item }
            row['id'] = index
            return row
        })
    }

    const createColumnsFromObj = (obj, label, fullKey) => {
        // Add each key from each value
        const outputSet = new Set()
        Object.values(obj).forEach((item) => {
          Object.keys(item).forEach((subKey) => {
            const dotNotatedKey = `${fullKey}.${subKey}`
            if(label.hasOwnProperty(dotNotatedKey) && label[dotNotatedKey].hasOwnProperty("hidden") && label[dotNotatedKey]["hidden"] === true){
              //Ignore items that need to be hidden
            }
            else {
              outputSet.add(dotNotatedKey)
            }
          })
        })
        return Array.from(outputSet).map((item) => {
          const columnHeader = {
            'field': item.split('.').pop(),
            'headerName': label[item]?.label || item.charAt(0).toUpperCase() + item.slice(1),
            'editable': true
          }
          if(label.hasOwnProperty(item) && label[item].hasOwnProperty("disabled") && label[item]["disabled"] === true){
            columnHeader['editable'] = false
          }
          if(label.hasOwnProperty(item) && label[item].hasOwnProperty("type") && label[item]["type"] === "checkbox"){
            columnHeader['editable'] = false
            columnHeader['renderCell'] = (params) =>
            (
              <Switch
                sx={{
                '& .MuiSwitch-switchBase.Mui-checked': {
                    color: 'rgb(178, 235, 177)',
                    '&:hover': {
                        backgroundColor: 'rgba(178, 235, 177,0.6)',
                    },
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: 'rgba(178, 235, 177,0.6)'
                    },
                }}
                inputProps={{ 'aria-label': 'controlled' }} 
                checked={params.value}
                onChange={() => datagridSwitchUpdate(params)}
            />
          )
          }
          return columnHeader
        })
      }

    

    return (
        <Box
            m={1}
            height={'500px'}
            width={'500px'}
            sx={{
                borderWidth: 1,
                borderStyle: "solid",
                borderColor: "rgba(139, 142, 146, 0.7)"

            }}
        >
            <DataGridPro
                sx={{
                    bgcolor: "rgba(0,0,0,0.9)",
                    boxShadow: 2,
                    border: 0,
                    borderRadius: '0px',
                    '.strikeout':{
                        opacity: '0.4',
                        textDecoration:'line-through',
                        textDecorationColor:'white',
                    },
                    '.strikeout::hover':{
                        bgcolor:'red'
                    },
                    '& .MuiCircularProgress-svg':{
                        color:'green'
    
                    },
                    '& .MuiDataGrid-cell:focus': {
                        outline:'solid silver 1px'
                    },
                    '& .MuiSvgIcon-root': {
                        color: "rgba(178, 186, 194, 0.4)"
                    },
                    '& .MuiDataGrid-footerContainer': {
                        borderTop: "1px solid rgba(224, 224, 224, 0.8)"
                    },
                    '& .MuiDataGrid-overlay': {
                        backgroundColor: "rgba(255, 255, 255, 0.01)"
                    },
                    '& .MuiDataGrid-row.Mui-selected': {
                        backgroundColor: "rgba(36, 108, 164, 0.35)",
                    },
                    '& .MuiDataGrid-row.Mui-selected.Mui-hovered': {
                        backgroundColor: "rgba(36, 108, 164, 0.35)",
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                        color: "rgb(255, 255, 255)",
                        fontWeight: "bold",
                    },
                    '& .MuiDataGrid-columnHeadersInner': {
                        backgroundColor: "rgba(0, 0,0 , 0.1)",
                    },
                    '& .MuiDataGrid-pinnedColumns': {
                        backgroundColor: "#1c2025",
                        backgroundImage: 'none',
                        boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 50%), 0px 2px 2px 0px rgb(0 0 0 / 40%), 0px 1px 5px 0px rgb(36 108 164 / 90%)',
                    },
                    '& .MuiDataGrid-pinnedColumnHeaders': {
                        backgroundColor: "rgb(40,44,52)",
                        backgroundImage: 'none',
                        boxShadow: 'none',
                        borderColor: "rgba(77, 78, 82, 0.7)",
                    },
                    '& .MuiDataGrid-cell': {
                    color: "rgb(255, 255, 255)",
                    borderColor: "rgba(77, 78, 82, 0.7)",
                    },
                    '& .MuiLinearProgress-root':{
                        backgroundColor:'green'
                    }
                }}
                hideFooter={true}
                rowHeight={80}
                rows={createRowsFromObj(rows) || []}
                columns={createColumnsFromObj(rows, label, fullKey)} 
                loading={rows.length == 0 ? true : false}
                apiRef={apiRef}
                disableRowSelectionOnClick
            />
        </Box>
    )
 }
